"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const _ = require("lodash");
const react_1 = require("react");
const components_1 = require("./../../../../components");
const Input_1 = require("./Input");
exports.mapStringArrayToCommaSeparatedText = (words) => {
    return words
        .map(word => ` ${word}`)
        .join(',')
        .trim();
};
exports.mapStringCommaSeparatedToArray = (text) => {
    return text
        .split(',')
        .map(word => word.trim())
        .filter(word => !!word);
};
class HorizontalFormFieldInput extends react_1.PureComponent {
    constructor(props) {
        super(props);
        this.getValue = () => {
            let value = this.updatedFromInside ? this.state.text : this.props.value;
            if (_.isArray(value)) {
                value = exports.mapStringArrayToCommaSeparatedText(this.props.value);
            }
            return value;
        };
        this.handleChange = (e) => {
            const { value } = e.target;
            const { valueIsArray } = this.props;
            this.setState({ text: e.target.value });
            this.updatedFromInside = true;
            const fieldValue = valueIsArray ? exports.mapStringCommaSeparatedToArray(value) : value;
            this.props.onChange(fieldValue);
        };
        const value = _.isArray(props.value)
            ? props.value
                .map(word => ` ${word}`)
                .join(',')
                .trim()
            : props.value;
        this.state = {
            text: value,
        };
    }
    componentDidUpdate(prevProps) {
        this.updatedFromInside = false;
    }
    render() {
        const _a = _.omit(this.props, ['className', 'id', 'value', 'onChange']), { helpText, label, name, success, successMessage, required, valueIsArray } = _a, otherProps = __rest(_a, ["helpText", "label", "name", "success", "successMessage", "required", "valueIsArray"]);
        const labelId = `label-for-${name}`;
        const value = this.getValue();
        return (React.createElement(components_1.FormGroup, { row: true, "aria-labelledby": labelId, "aria-describedby": name },
            React.createElement(components_1.Label, { className: "col-12", sm: 3, id: labelId, for: name },
                label,
                required && ' *'),
            React.createElement(components_1.Col, { className: "col-12", sm: 9 },
                React.createElement(Input_1.Input, Object.assign({ name: name, id: name, value: value, onChange: this.handleChange }, otherProps)),
                success && (React.createElement(components_1.FormFeedback, null, successMessage)),
                !!helpText && (React.createElement(components_1.FormText, { tag: "span", color: "muted" }, helpText)))));
    }
}
exports.HorizontalFormFieldInput = HorizontalFormFieldInput;



//////////////////
// WEBPACK FOOTER
// ./src/demo/examples/FormExample/InputText/HorizontalFormFieldInput.tsx
// module id = 464
// module chunks = 0